// extracted by mini-css-extract-plugin
export default {"cls1":"VeloModalSheetHeaderTitle-Skeleton_cls1__eKxeL","cls2":"VeloModalSheetHeaderTitle-Skeleton_cls2__aUplG VeloModalSheetHeaderTitle-Skeleton_cls1__eKxeL"};